<template>
    <div id="company-information">

        <div v-if="showEditCompanyAddress">
            <edit-company-address :account="account" @cancel="cancelEditCompanyAddress" @update="update"></edit-company-address>
        </div>

        <div v-if="showEditCompanyInfo">
            <edit-company-info :account="account" @cancel="cancelEditCompanyInfo" @update="update"></edit-company-info>
        </div>

        <div v-if="showEditFleetInfo">
            <edit-fleet-info :account="account" @cancel="cancelEditFleetInfo" @update="update"></edit-fleet-info>
        </div>

        <div class="company-information-heading">
            <h1 class="td-h2 mt-0">
                {{ account.n }}
            </h1>
        </div>

        <div class="account-info-cards">
            <div class="mb-2 td-card border main-info rounded">
                <div class="account-info">
                    <div>
                        <h4 class="card-heading">
                            Company Info
                            <span v-if="isGeneralAdmin">
                                <icon class="ml-1 td-text-primary td-link" name="faPenToSquare" type="solid" @click="showEditCompanyInfo = !showEditCompanyInfo"></icon>
                            </span>
                        </h4>
                    </div>
                    <p>
                        <strong class="mr-1">Name: </strong> {{ account.n }}
                    </p>
                    <p>
                        <strong class="mr-1">Email: </strong> {{ account.info.email }}
                    </p>
                    <p>
                        <strong class="mr-1">Office: </strong> {{ formatPhoneString(account.info.officeNumber) }}
                    </p>
                    <p>
                        <strong class="mr-1">Fax: </strong> {{ formatPhoneString(account.info.faxNumber) }}
                    </p>
                    <p>
                        <strong class="mr-1">Website: </strong> {{ account.info.website }}
                    </p>
                </div>

                <div class="account-address">
                    <div>
                        <h4 class="card-heading">
                            Company Address
                            <span v-if="isGeneralAdmin">
                                <icon class="ml-1 td-text-primary td-link" name="faPenToSquare" type="solid" @click="showEditCompanyAddress = !showEditCompanyAddress"></icon>
                            </span>
                        </h4>
                    </div>
                    <p>
                        <strong class="mr-1">Line 1: </strong> {{ account.info.address?.line1 ?? "" }}
                    </p>
                    <p>
                        <strong class="mr-1">City: </strong> {{ account.info.address?.city ?? "" }}
                    </p>
                    <p>
                        <strong class="mr-1">Region: </strong> {{ account.info.address?.regionCode ?? "" }}
                    </p>
                    <p>
                        <strong class="mr-1">Zip Code/Postal Code: </strong> {{ account.info.address?.postalCode ?? "" }}
                    </p>
                </div>

                <div class="account-fleet" v-if="account.accountType == 3">
                    <div>
                        <h4 class="card-heading">
                            Fleet Info
                            <span>
                                <icon class="ml-1 td-text-primary td-link" name="faPenToSquare" type="solid" @click="showEditFleetInfo = !showEditFleetInfo"></icon>
                            </span>
                        </h4>
                    </div>
                    <p>
                        <strong class="mr-1">Fleet Size: </strong> {{ account.properties.fleetSize }}
                    </p>
                    <p>
                        <strong class="mr-1">IFTA Number: </strong> {{ account.properties.iftaNumber }}
                    </p>
                    <p>
                        <strong class="mr-1">DOT Number: </strong> {{ account.properties.dotNumber }}
                    </p>
                </div>
            </div>
        </div>

        <status-message></status-message>

        <div v-if="locations.results && locations.results.length > 0">
            <div style="display: inline;">
                <h4 class="card-heading">
                    Listings
                </h4>
            </div>
            <div class="mb-3">
                <a href="/listings" class="td-btn secondary">Manage Listings</a>
            </div>
        </div>

        <div v-if="locations.results && locations.results.length > 0">
            <generic-pager :currentCount="locations.results.length" :count="locationsCount" :pageCount="pageCount" :lastObject="lastPagerObject" @updateList="updateList" :reset="resetList" :loading="isLoading">
                <div class="td-table-container mt-0">
                    <table cellspacing="0" cellpadding="0" class="td-table">
                        <thead>
                            <tr class="table-header">
                                <th>Name</th>
                                <th>Status</th>
                                <th>Street Address</th>
                                <th>Phone Number</th>
                                <th>Pending Edits</th>
                            </tr>
                        </thead>
                        <tbody v-if="!isLoading && locations.results.length > 0" v-for="(location, index) in locations.results" :key="locations.id" class="rows-container">
                            <tr class="table-row main-row">
                                <td class="name">
                                    <h2 class="td-h5 mt-0">
                                        {{ getLocationDisplay(location) }}
                                    </h2>
                                </td>
                                <td class="status">
                                    {{ getStatus(location)}}
                                </td>
                                <td class="street-address">
                                    {{ getStreetAddress(location) }}
                                </td>
                                <td class="phone-numbers">
                                    {{ formatPhoneString(location.phoneNumbers['Phone']) ?? "" }}
                                </td>
                                <td class="pending-edits">
                                    {{ getHasEdit(location) }}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="isLoading">
                            <tr><th colspan="5"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                        </tbody>
                    </table>

                </div>
            </generic-pager>
        </div>

    </div>
</template>

<script>
    import script from './CompanyInformation';
    export default script;
</script>

<style lang="less">
    @import './CompanyInformation.less';
</style>